import React, { useState, useEffect } from "react";
import {
  Card,
  Row,
  Col,
  Tag,
  message,
  Input,
  Button,
  Table,
  Modal,
  Spin,
  Typography,
} from "antd";
import {
  PlusOutlined,
  SearchOutlined,
  EditOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import DriversForm from "./driversForm";
import { NavLink } from "react-router-dom";
import axios from "axios";

const { Title } = Typography;
const { Search } = Input;

const Drivers = () => {
  const [irModalVisible, setProjectModalVisible] = useState(false);
  const [formData, setFormData] = useState({});
  const [driversData, setDriversData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchData(); // Fetch data when the component mounts
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get("http://93.127.203.113:5005/drivers");
      setDriversData(response.data);
      setFilteredData(response.data);
    } catch (error) {
      message.error("Unable to load data!");
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (value) => {
    setSearchQuery(value);
    const lowerSearch = value.toLowerCase();
    const filteredData = driversData.filter((driver) =>
      Object.keys(driver).some((key) =>
        String(driver[key]).toLowerCase().includes(lowerSearch)
      )
    );
    setFilteredData(filteredData);
  };

  const highlightText = (text, search) => {
    if (!search) return text;
    const regex = new RegExp(`(${search})`, "gi");
    const parts = text.split(regex);

    return parts.map((part, index) =>
      regex.test(part) ? (
        <span
          key={index}
          style={{
            backgroundColor: "yellow",
            fontWeight: "bold",
          }}
        >
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  const driversColumns = [
    {
      title: <span style={{ fontWeight: "bold" }}>First Name</span>,
      dataIndex: "firstName",
      key: "firstName",
      render: (text) => highlightText(text, searchQuery),
    },
    {
      title: <span style={{ fontWeight: "bold" }}>Last Name</span>,
      dataIndex: "lastName",
      key: "lastName",
      render: (text) => highlightText(text, searchQuery),
    },
    {
      title: <span style={{ fontWeight: "bold" }}>Phone Number</span>,
      dataIndex: "phoneNumber",
      key: "phoneNumber",
      render: (text) => highlightText(text, searchQuery),
    },
    {
      title: <span style={{ fontWeight: "bold", color: "#0c8c49" }}>Status</span>,
      dataIndex: "status",
      key: "status",
      render: (status) => {
        const color =
          status === "Active"
            ? "green"
            : status === "Pending"
            ? "orange"
            : status === "Inactive"
            ? "red"
            : "green";
        return (
          <Tag color={color}>{highlightText(status?.toUpperCase() || "Active", searchQuery)}</Tag>
        );
      },
    },
    {
      title: <span style={{ fontWeight: "bold" }}>Actions</span>,
      key: "actions",
      render: (_, record) => (
        <>
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => {
              setFormData(record);
              setProjectModalVisible(true);
            }}
            style={{ marginRight: 8, color: "#0c8c49" }}
          >
            Edit
          </Button>
          <Button type="link">
            <NavLink
              to={`/driverDetails/${record.id}`}
              style={{ color: "#0c8c49" }}
            >
              <InfoCircleOutlined /> &nbsp;Details
            </NavLink>
          </Button>
        </>
      ),
    },
  ];

  return (
    <div style={{ padding: "20px" }}>
      <Card
        style={{
          borderRadius: "10px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          borderTop: "5px solid #0c8c49",
        }}
      >
        <Title level={4} style={{ color: "#0c8c49", marginBottom: "20px" }}>
          Drivers
        </Title>
        <Row gutter={[16, 16]} align="middle" style={{ marginBottom: "20px" }}>
          <Col span={18}>
            <Search
              placeholder="Search Drivers"
              allowClear
              enterButton={<SearchOutlined />}
              onSearch={handleSearch}
              onChange={(e) => handleSearch(e.target.value)}
              style={{ width: "60%" }}
            />
          </Col>
          <Col span={6} style={{ textAlign: "right" }}>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => {
                setFormData({});
                setProjectModalVisible(true);
              }}
              style={{
                backgroundColor: "#0c8c49",
                borderColor: "#0c8c49",
              }}
            >
              Add Driver
            </Button>
          </Col>
        </Row>
        {loading ? (
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <Spin size="large" />
          </div>
        ) : (
          <Table
            columns={driversColumns}
            dataSource={filteredData}
            rowKey="id"
            pagination={{ pageSize: 5 }}
            bordered
          />
        )}
      </Card>

      <Modal
        title={formData.id ? "Edit Driver" : "Add Driver"}
        visible={irModalVisible}
        onCancel={() => setProjectModalVisible(false)}
        footer={null}
        centered
        width="50%"
        style={{ borderRadius: "10px" }}
        bodyStyle={{
          padding: "20px",
          borderRadius: "10px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        }}
      >
        <DriversForm
          formData={formData}
          setFormData={setFormData}
          closeModal={() => setProjectModalVisible(false)}
          refetchData={fetchData}
        />
      </Modal>
    </div>
  );
};

export default Drivers;
